import React,{ useEffect } from 'react';
import style from './index.module.scss';
import {Banner} from "@src/routes/main/Home/components/Banner";
import {Advantage} from "@src/routes/main/Home/components/Advantage";
import {Scenes} from "@src/routes/main/Home/components/Scenes";
import homeBackground from '../../../assets/imgs/home/bg.png';
import homeBackgroundMin from '../../../assets/imgs/home/bg-min.png';
// 导入antd组件
import { Image } from "antd";

export default function Home() {
  useEffect(() => {
    // 跳到顶部
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className={style.home}>
        <Image
          className={style.home_bg}
          width="100%"
          src={homeBackground}
          preview={false}
          placeholder={
            <Image
              className={style.home_bg}
              width="100%"
              src={homeBackgroundMin}
              preview={false}
            />
          }
        />
        <Banner />
        <Advantage />
        <Scenes />
      </div>
    </>
  );
}
